import React, { useEffect, useState } from 'react';
import './VideoPopup.scss';

import { useScrollYPosition } from 'react-use-scroll-position';
const Header = () => {

  const [passedVideo, setPassVideo] = useState(false);
  const [clickedClosed, setClosed] = useState(false);
  const scrollPos = useScrollYPosition();

  useEffect(() => {
    const videoPopup = document.querySelector('#popup-trigger');
    setPassVideo(scrollPos > videoPopup.offsetTop && !clickedClosed)
  }, [scrollPos])
  return (
    <div id="video-popup">
      <div className={`popup ${passedVideo && !clickedClosed ? 'popped' : ''}`}>
        <span className="close-button" onClick={() => {
          setClosed(true);
          setPassVideo(false);
        }}>X</span>
        <iframe className={`emi`} src="https://player.vimeo.com/video/541727124" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  );
}

export default Header;
